import addFreightSlice from './truckManagementSlices/freightSlice';
import {
  deactivateNameLoads,
  deleteAllLoad,
  loadAll,
  loadsActiveFreights,
  loadsActiveNames,
  loadsallLoad,
  updateAllLoad
} from './truckManagementSlices/loadsSlice';
import logisticSlice from './truckManagementSlices/logisticSlice';
import {
  addTrailerReducer,
  getTrailerReducer,
  deactivateTrailerReducer,
  updateTrailerReducer,
  deleteTrailerReducer,
  fileUploadTrailerReducer,
  addFileStatusReducer
} from './truckManagementSlices/trailerSlice';
import {
  fileUploadReducer,
  getTruckReducer,
  updateTruckReducer
} from './truckManagementSlices/truckSlice';
import {
  addMaintenanceReducer,
  getMaintenanceReducer,
  getVehicleNumber,
  makeDropDownReducer,
  partDropDownReducer,
  truckNumbersReducer,
  typeDropDownReducer,
  vehicleNumberReducer,
  vehicleTypeReducer
} from './truckManagementSlices/maintenanceSlice';
import {
  addDispatchReducer,
  deactivateDispatchReducer,
  deleteAlldispatch,
  dispatchDropdownData,
  dispatchDropDownDataTrailer,
  getdispatchData,
  updatedispatchReducer
} from './truckManagementSlices/dispatchSlice';

import {
  addInspectionData,
  inspectionSlice
} from './truckManagementSlices/inspectionSlice';
import vehicleConfigManagerFile from './truckManagementSlices/vehicleConfigManagerSlice';
export const truckManagementReducer = {
  AddFreight: addFreightSlice,

  Logistics: logisticSlice,
  loads: loadAll,
  activeNames: loadsActiveNames,
  freightactive: loadsActiveFreights,
  deactivateLoads: deactivateNameLoads,
  loadsAll: loadsallLoad,
  updateLoads: updateAllLoad,
  deleteAllLoads: deleteAllLoad,

  addTrailer: addTrailerReducer,
  getTrailer: getTrailerReducer,
  deleteTrailer: deleteTrailerReducer,
  deactivateTrailer: deactivateTrailerReducer,
  updateTrailer: updateTrailerReducer,
  getTruck: getTruckReducer,
  updateTruck: updateTruckReducer,
  addMaintenance: addMaintenanceReducer,
  getMaintenance: getMaintenanceReducer,
  addDispatch: addDispatchReducer,
  truckNumbers: truckNumbersReducer,
  dispatchDropdown: dispatchDropdownData,
  dispatchTrailer: dispatchDropDownDataTrailer,
  dispatchUpdate: updatedispatchReducer,
  deleteAlldispatchs: deleteAlldispatch,
  addInspection: addInspectionData,
  dispatchData: getdispatchData,
  deactivateDispatch: deactivateDispatchReducer,
  getVehicleType: vehicleTypeReducer,
  getVehicleNumber: vehicleNumberReducer,
  partDropDown: partDropDownReducer,
  makeDropDown: makeDropDownReducer,
  typeDropDown: typeDropDownReducer,

  getInspection: inspectionSlice,
  addFileStatus: addFileStatusReducer,
  vehicleConfigData: vehicleConfigManagerFile
};
